<template>
  <b-modal v-model="modal" :title="title" size="xl" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveUser()" autocomplete="off">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="name">Nome</label>
                <input
                  id="name"
                  v-model="user.name"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.user.name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.user.name.required"
                  class="invalid-feedback"
                >
                  O campo nome é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="email">E-mail</label>
                <input
                  id="email"
                  v-model="user.email"
                  name="email"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.user.email.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.user.email.required"
                  class="invalid-feedback"
                >
                  O campo email é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="password">Senha</label>
                <span v-if="!user.id">
                  <input
                    id="password"
                    v-model="user.password"
                    name="password"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.user.password.$error
                    }"
                  />
                  <div
                    v-if="submitted && !$v.user.password.required"
                    class="invalid-feedback"
                  >
                    O campo senha é obrigatório.
                  </div>
                </span>
                <span v-if="user.id">
                  <input
                    id="password"
                    v-model="user.password"
                    name="password"
                    type="text"
                    class="form-control"
                  />
                </span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="role">Função</label>
                <multiselect
                  v-model="selected"
                  :options="roles"
                  class="helo"
                  :max-height="180"
                  placeholder="Selecione uma função"
                  label="name"
                  track-by="id"
                  :class="{
                    'is-invalid': submitted && $v.user.role.$error,
                  }"
                  :classError="$v.user.role.$error ? true : false"
                  @input="onRoleChange"
                >
                </multiselect>
                <div
                  v-if="submitted && !$v.user.role.required"
                  class="invalid-feedback"
                >
                  O campo função é obrigatório.
                </div>
              </div>
            </div>
          </div>

          <!-- Permissions Section -->
          <div class="row mt-4">
            <div class="col-sm-12">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <label class="mb-0"><strong>Permissões</strong></label>
                <div>
                  <button type="button" class="btn btn-sm btn-outline-primary mr-2" @click="selectAllPermissions">
                    Selecionar Todas
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearAllPermissions">
                    Limpar Todas
                  </button>
                </div>
              </div>
              <p class="text-muted small mb-3">
                <i class="bx bx-info-circle"></i>
                Permissões marcadas em <span class="badge badge-soft-primary">azul</span> são herdadas da função.
                Permissões adicionais podem ser atribuídas diretamente ao usuário.
              </p>
            </div>
            <div class="col-sm-12">
              <div role="tablist">
                <b-card no-body class="mb-1 shadow-none" v-for="(perms, group) in permissions" :key="group">
                  <b-card-header header-tag="header" role="tab" class="bg-light">
                    <h6 class="m-0 d-flex justify-content-between align-items-center">
                      <a
                        v-b-toggle="'accordion-' + sanitizeId(group)"
                        class="text-dark"
                        href="javascript: void(0);"
                      >
                        <i class="bx bx-chevron-down mr-1"></i>
                        {{ group }}
                      </a>
                      <span class="badge badge-primary">{{ getGroupSelectedCount(perms) }}/{{ perms.length }}</span>
                    </h6>
                  </b-card-header>
                  <b-collapse :id="'accordion-' + sanitizeId(group)" accordion="perm" role="tabpanel">
                    <b-card-body>
                      <div class="row">
                        <div class="col-md-6 col-lg-4" v-for="(p, i) in perms" :key="i">
                          <div class="form-check form-switch mb-2">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :id="'perm-' + p.id"
                              v-model="user.permissions"
                              :value="p.id"
                            />
                            <label
                              class="form-check-label"
                              :for="'perm-' + p.id"
                              :class="{ 'text-primary': isRolePermission(p.id) }"
                            >
                              {{ p.description }}
                              <i v-if="isRolePermission(p.id)" class="bx bx-shield text-primary ml-1" title="Permissão da função"></i>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveUser()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import Multiselect from 'vue-multiselect'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import roleService from '@/pages/roles/services'

export default {
  components: {
    Loading,
    Multiselect
  },
  props: {
    iduser: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo Usuário',
      loading: true,
      selected: '',
      fullPage: true,
      submitted: false,
      roles: [],
      permissions: {},
      rolePermissions: [],
      optionsRooms: [],
      user: {
        permissions: []
      },
      modal: false
    }
  },
  validations () {
    if (this.user.id) {
      return {
        user: {
          name: { required },
          email: { required },
          role: { required }
        }
      }
    } else {
      return {
        user: {
          name: { required },
          email: { required },
          password: { required },
          role: { required }
        }
      }
    }
  },
  methods: {
    ...mapActions('users', {
      getUser: 'getUser',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Usuário'
        this.getUser(id).then((data) => {
          this.user = { ...this.data }

          // Initialize permissions array
          let allUserPermissions = []

          // Add direct permissions
          if (this.data.direct_permissions && Array.isArray(this.data.direct_permissions)) {
            allUserPermissions = [...this.data.direct_permissions]
          }

          // Set selected role - find from loaded roles list to get permissions
          if (this.data.roles && this.data.roles.data && this.data.roles.data.length > 0) {
            const userRoleId = this.data.roles.data[0].id
            // Find the matching role from the loaded roles (which have permissions)
            const matchedRole = this.roles.find(r => r.id === userRoleId)
            if (matchedRole) {
              this.selected = matchedRole
              // Add role permissions to the user permissions
              if (matchedRole.permissions && Array.isArray(matchedRole.permissions)) {
                matchedRole.permissions.forEach(p => {
                  if (!allUserPermissions.includes(p.id)) {
                    allUserPermissions.push(p.id)
                  }
                })
              }
            } else {
              // Fallback to user's role data
              this.selected = this.data.roles.data[0]
            }
            this.updateRolePermissions()
          }

          // Set all permissions (role + direct)
          this.user.permissions = allUserPermissions
        }).then(() => {
          this.loading = false
        })
      }
    },
    async loadRoles () {
      const res = await roleService.list()
      this.roles = res.data.data
      return this.roles
    },
    async loadPermissions () {
      const res = await roleService.listPermissions()
      this.permissions = res.data
      return this.permissions
    },
    onRoleChange () {
      this.updateRolePermissions()
    },
    updateRolePermissions () {
      if (this.selected && this.selected.permissions) {
        // Handle both array and object with data property
        let perms = this.selected.permissions
        if (perms.data) {
          perms = perms.data
        }
        if (Array.isArray(perms)) {
          this.rolePermissions = perms.map(p => p.id)
        } else {
          this.rolePermissions = []
        }
      } else {
        this.rolePermissions = []
      }
    },
    isRolePermission (permId) {
      return this.rolePermissions.includes(permId)
    },
    selectAllPermissions () {
      const allPermIds = []
      Object.values(this.permissions).forEach(group => {
        group.forEach(p => {
          if (!allPermIds.includes(p.id)) {
            allPermIds.push(p.id)
          }
        })
      })
      this.user.permissions = allPermIds
    },
    clearAllPermissions () {
      this.user.permissions = []
    },
    getGroupSelectedCount (perms) {
      return perms.filter(p => this.user.permissions.includes(p.id) || this.rolePermissions.includes(p.id)).length
    },
    sanitizeId (str) {
      return str.replace(/[^a-zA-Z0-9]/g, '-')
    },
    async open (id = null) {
      this.modal = true
      this.loading = true
      // Load roles and permissions first
      await Promise.all([
        this.loadRoles(),
        this.loadPermissions()
      ])
      if (id) {
        this.loadItem(id)
        return
      }
      this.user = { permissions: [] }
      this.rolePermissions = []
      this.loading = false
    },
    async saveUser () {
      this.submitted = true
      if (this.selected) {
        this.user.role = this.selected.id
      }
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true

      // Prepare data to save - filter out role permissions to only send direct permissions
      const dataToSave = { ...this.user }
      if (dataToSave.permissions && this.rolePermissions.length > 0) {
        // Only send permissions that are NOT from the role (direct permissions)
        dataToSave.permissions = dataToSave.permissions.filter(
          permId => !this.rolePermissions.includes(permId)
        )
      }

      await this.postData(dataToSave).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.submitted = false
      this.modal = false
      this.user = { permissions: [] }
      this.selected = ''
      this.rolePermissions = []
      this.title = 'Novo Usuário'
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('users', { data: 'admin_user' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.form-check-input:checked {
    background-color: #556ee6;
    border-color: #556ee6;
}
.text-primary {
    color: #556ee6 !important;
}
.badge-soft-primary {
    background-color: rgba(85, 110, 230, 0.18);
    color: #556ee6;
}
.card-header.bg-light {
    background-color: #f8f9fa !important;
}
</style>
